import _ from "lodash";
import React, { useState } from "react";
import EditChannelProvider from "./ChannelContext";
import {
  handleEditChannelInfo,
  handleEditDepartmentChannelInfo,
} from "MessagingV2/modules/MessagingModule";
import { connect } from "react-redux";
import { useCallback } from "react";

const ChannelInfo = props => {
  const {
    children,
    chatId,
    handleEditChannelInfo,
    handleEditDepartmentChannelInfo,
    onClose,
    channelLabel: channelNameInit,
    channelDescription: channelDescriptionInit,
    channelProfileImage: channelProfileImageInit,
    channelBannerMessage: channelBannerMessageInit,
    isDepartmentChannel,
  } = props;

  const [channelInfo, setChannelInfo] = useState({
    channelName: channelNameInit,
    channelDescription: channelDescriptionInit,
    channelProfileImage: channelProfileImageInit,
    channelBannerMessage: channelBannerMessageInit,
  });

  const handleChannelInfoChange = useCallback(channelInfo => {
    setChannelInfo(prevState => ({
      ...prevState,
      ...channelInfo,
    }));
  }, []);

  const [isEditButtonDisable, setIsEditButtonDisable] = useState(false);

  const onEditChannelSubmit = async () => {
    setIsEditButtonDisable(true);
    if (isDepartmentChannel) {
      handleEditDepartmentChannelInfo({
        label: channelInfo.channelName,
        bannerMessage: channelInfo.channelBannerMessage,
        chatId,
      });
    } else {
      handleEditChannelInfo({
        label: channelInfo.channelName,
        description: channelInfo.channelDescription,
        profileImage: channelInfo.channelProfileImage,
        bannerMessage: channelInfo.channelBannerMessage,
        chatId,
      });
    }
    onClose();
  };

  const errorValidation = () => {
    return isEditButtonDisable || _.isEmpty(channelInfo.channelName);
  };

  const providerValue = {
    channelName: channelInfo.channelName,
    channelDescription: channelInfo.channelDescription,
    channelProfileImage: channelInfo.channelProfileImage,
    channelBannerMessage: channelInfo.channelBannerMessage,
    handleChannelInfoChange,
    onEditChannelSubmit,
    onClose,
    errorValidation,
  };

  return (
    <EditChannelProvider value={providerValue}>{children}</EditChannelProvider>
  );
};

const mapActionCreators = {
  handleEditChannelInfo,
  handleEditDepartmentChannelInfo,
};

export default connect(undefined, mapActionCreators)(ChannelInfo);
